export var tokens = {
  spacing: {
    SPACING_0: 0,
    SPACING_1: 1,
    SPACING_2: 2,
    SPACING_3: 3,
    SPACING_4: 4,
    SPACING_5: 5,
    SPACING_6: 6,
    SPACING_7: 7,
    SPACING_8: 8,
    SPACING_9: 9,
    SPACING_10: 10,
    SPACING_11: 11,
    SPACING_12: 12,
    SPACING_13: 13,
    SPACING_14: 14,
    SPACING_15: 15,
    SPACING_16: 16,
    SPACING_17: 17,
    SPACING_18: 18,
    SPACING_20: 20,
    SPACING_22: 22,
    SPACING_24: 24,
    SPACING_26: 26,
    SPACING_28: 28,
    SPACING_30: 30,
    SPACING_32: 32,
    SPACING_34: 34,
    SPACING_36: 36,
    SPACING_38: 38,
    SPACING_40: 40,
    SPACING_42: 42,
    SPACING_44: 44,
    SPACING_46: 46,
    SPACING_48: 48,
    SPACING_50: 50,
    SPACING_52: 52,
    SPACING_56: 56,
    SPACING_60: 60,
    SPACING_64: 64,
    SPACING_68: 68,
    SPACING_72: 72,
    SPACING_74: 74,
    SPACING_80: 80,
    SPACING_96: 96,
    SPACING_100: 100,
    SPACING_128: 128,
    SPACING_160: 160,
    SPACING_192: 192,
    SPACING_335: 335,
    SPACING_442: 442
  },
  borderRadius: {
    BORDER_RADIUS_2: 2,
    BORDER_RADIUS_4: 4,
    BORDER_RADIUS_7: 7,
    BORDER_RADIUS_8: 8,
    BORDER_RADIUS_10: 10,
    BORDER_RADIUS_12: 12,
    BORDER_RADIUS_14: 14,
    BORDER_RADIUS_15: 15,
    BORDER_RADIUS_16: 16,
    BORDER_RADIUS_24: 24,
    BORDER_RADIUS_32: 32,
    BORDER_RADIUS_100: 100
  },
  breakPoints: {
    xs: {
      breakpoint: 0
    },
    sm: {
      breakpoint: 576
    },
    md: {
      breakpoint: 768
    },
    lg: {
      breakpoint: 1200
    },
    xl: {
      breakpoint: 1400
    }
  }
};